<div *ngIf="!isAppLoadedForSSO" class="landing">
  <div class="header-wrap">
    <header-alert></header-alert>
    <app-cookie-banner></app-cookie-banner>
    <header class="header p-lg-5 p-md-5">
      <div class="row px-lg-10 py-lg-2 px-md-10 py-md-2 ">
        <div class="col-4">
          <div class="header-logo-wrap pt-lg-2 pt-md-2">
            <img src="/assets/images/login-panel/logo-full.svg" alt="Amadeus Direct" />
          </div>
        </div>
        <div class="col-8">
          <ng-select
            class="language-select-dropdown option option-selected
            option-hover option-selected-border language-select-hebrew"
            labelForId="languageSelect"
            [selectOnTab]="true"
            name="languageSelect"
            [items]="languages"
            [(ngModel)]="selectedLng"
            [ngModelOptions]="{ standalone: true }"
            [searchable]="false"
            [clearable]="false"
            bindLabel="title"
            (change)="changeClpLng(selectedLng)"
          >
          </ng-select>
        </div>
      </div>
    </header>
  </div>

  <div class="title-wrap photo-banner photo-banner-full-screen">
    <div class="container banner-content px-lg-10 px-md-10">
      <div class="row px-lg-8 px-md-8">
        <div class="text-wrapper col-lg-7 col-sm-12 ps-lg-5 ps-md-5">
          <h2 class="h1 display-1 main-title" style="margin-top: -0.7rem;">Amadeus Direct</h2>
        </div>

        <span
          class="w-auto scroll-down-btn fs-1 fa-arrow-down-long text-dark"
          (click)="scrollTo('amadeus-links')"
        ></span>
          <div class="redirection-panel col-lg-7 col-sm-12 ps-lg-5 ps-md-5" *ngIf="loadRedirectionComponent">
            <div class="login-panel-wrap py-lg-5 py-md-5">
              <div class="ml-5">
                <ng-container>
                  <div class="header-logo-wrap pt-lg-2 pt-md-2 mt-7">
                    <img src="/assets/images/redirection-panel/Layer_1.svg" alt="Redirection Logo" />
                  </div>
                </ng-container>
                <ng-container>
                  <div class="h1 login-panel-title mt-5" [innerHTML]="landingWeHaveMovedAndChangedName"></div>
                </ng-container>
                <ng-container>
                  <div>
                    <div class="fw-semibold" [innerHTML]="landingRedirectionMessageOne"></div>
                    <div class="fw-semibold mt-3" [innerHTML]="landingRedirectionMessageTwo"></div>
                  </div>
                </ng-container>
                <ng-container>
                  <button
                    type="button"
                    class="btn btn-primary mb-2 mb-md-7 me-2 mt-5"
                    [innerHTML]="landingGoToASH"
                    (click)="redirectToAsh()"
                  ></button>
                </ng-container>
              </div>
            </div>
          </div>

          <div class="col-xxl-4 col-lg-5 col-sm-12" *ngIf="!loadRedirectionComponent">
            <div class="login-panel-wrap py-lg-5 py-md-5">
              <ng-container *ngIf="loginFormStep === 'form'">
                <div class="h1 login-panel-title" [innerHTML]="landingNewDesignSignIn"></div>

                <div class="creds">
                  {{ landingNewDesignUsingYour }}
                  <span [innerHTML]="landingNewDesignAmadeusCredentials" class="ama-creds-label"></span>
                  <ng-template #innerTooltipHtml>
                    <div [innerHTML]="landingLoginTooltip"></div>
                  </ng-template>
                  <span
                    class="fa-solid fa-circle-info ps-2 ama-creds-info-icon text-secondary"
                    [ngbTooltip]="landingLoginTooltip"
                    placement="top auto"
                  ></span>
                </div>
              </ng-container>

              <ng-container *ngIf="loginFormStep === 'forgetPwd'">
                <div class="h1 display-4 login-panel-title" [innerHTML]="loginForgetPasswordLabel"></div>
                <div class="my-3" [innerHTML]="loginForgetPasswordDetailLabel"></div>
              </ng-container>

              <ng-container *ngIf="loginFormStep === 'formPhone'">
                <div class="mb-7" [innerHTML]="mobileNumberEnterLabel"></div>
              </ng-container>

              <ng-container *ngIf="loginFormStep === 'formCode'">
                <div class="mb-7" [innerHTML]="verificationCodeEnterLabel"></div>
              </ng-container>

              <ng-container *ngIf="loginFormStep === 'formOtp'">
                <div class="mb-7" [innerHTML]="otpEnterLabel"></div>
              </ng-container>

              <div
                *ngIf="
                  (loggedInErrorModel$ | async) !== undefined ||
                  (directLoggedIn$ | async)?.loginStatus === 'ERROR' ||
                  unsignedAgreement === true
                "
                class="landing"
              >
                <div class="authorization-fail-wrap">
                  <div *ngIf="loggedInErrorMsg !== undefined">
                    <svg class="ico icon-m" width="24" height="24">
                      <use href="/assets/images/svg_ico/icons.svg#ic_error_danger"></use>
                    </svg>
                    <div class="alert-error" [innerHTML]="loggedInErrorMsg"></div>
                  </div>
                </div>
              </div>
              <ama-ng-login></ama-ng-login>
            </div>
          </div>
        <!--</ng-container>-->
      </div>
    </div>
  </div>
</div>
<div class="d-flex h-100 justify-content-center align-items-center" *ngIf="isAppLoadedForSSO">
  <div class="spinner-border text-primary" role="status"></div>
</div>
